import { render, staticRenderFns } from "./hot-products.vue?vue&type=template&id=7806bbd4&lang=pug&"
import script from "./hot-products.vue?vue&type=script&lang=js&"
export * from "./hot-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports